var base = require('core/login/login');
var formValidation = require('base/components/formValidation');
var recaptcha = require('core/components/recaptcha');
base.resetPassword = function () {
  $('.reset-password-form').submit(function (e) {
    var form = $(this);
    e.preventDefault();
    var url = form.attr('action');
    form.spinner().start();
    $('.reset-password-form').trigger('login:register', e);
    recaptcha.check(e, {
      url: url,
      type: 'post',
      dataType: 'json',
      data: form.serialize(),
      success: function success(data) {
        form.spinner().stop();
        if (!data.success) {
          formValidation(form, data);
        } else {
          $('.request-password-title').text(data.receivedMsgHeading);
          $('.request-password-subtitle').remove();
          $('.request-password-body').empty().append('<p>' + data.receivedMsgBody + '</p>');
          if (!data.mobile) {
            $('#submitEmailButton').text(data.buttonText).attr('data-dismiss', 'modal');
          } else {
            $('.send-email-btn').empty().html('<a href="' + data.returnUrl + '" class="btn btn-primary btn-block">' + data.buttonText + '</a>');
          }
        }
      },
      error: function error(err) {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        }
        form.spinner().stop();
      }
    });
    return false;
  });
};

/**
 * Syncs email confirm input field with email input field on mobile, since that
 * field is hidden on mobile.
 */
base.syncEmailConfirmField = function () {
  $emailConfirmField = $('#registration-form-email-confirm');
  $emailConfirmFormGroup = $emailConfirmField.closest('.form-group');
  if (window.isMobile() && $emailConfirmFormGroup.css('display') == 'none') {
    $emailConfirmField.removeAttr('required');
    $emailConfirmField.removeAttr('aria-required');
    $emailConfirmFormGroup.removeClass('required');
    $('#registration-form-email').keyup(function () {
      $emailConfirmField.val($(this).val());
    });
  }
};
module.exports = base;